import { defineMessages } from '@atlassian/jira-intl';
import { MSTEAM_APP_TYPE, SLACK_APP_TYPE, type AppType } from '../../../common/constants';

export const messages = defineMessages({
	slackWorkspaceConnectionSectionHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-workspace-connection-section-heading',
		defaultMessage: 'Slack',
		description: 'Heading of the slack workspace connection panel',
	},
	slackWorkspaceConnectionExpandButtonLabel: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-workspace-connection-expand-button-label',
		defaultMessage: 'Slack workspace connection section expander',
		description:
			'Label for the collapsible button aligned with the header in the new incident management section',
	},
	slackWorkspaceConnectionNoWorkspaceConnected: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-workspace-connection-no-workspace-connected',
		defaultMessage: 'No workspace connected',
		description:
			'Label for the lozenge indicating connected slack workspaces status when no workspaces are connected',
	},
	slackWorkspaceConnectionConnected: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-workspace-connection-connected',
		defaultMessage: 'Connected',
		description:
			'Label for the lozenge indicating connected slack workspaces status when workspaces are connected',
	},
	msteamsWorkspaceConnectionSectionHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.msteams-workspace-connection-section-heading',
		defaultMessage: 'Microsoft Teams',
		description: 'Heading of the Microsoft Teams workspace connection panel',
	},
	workspaceConnectionExpandButtonLabel: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.workspace-connection-expand-button-label',
		defaultMessage: 'Workspace connection section expander',
		description:
			'Label for the collapsible button aligned with the header in the new incident management section',
	},
	slackWorkspaceConnectionEnabled: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.slack-workspace-connection-enabled',
		defaultMessage:
			'{enabledWorkspacesCount, plural, one {# workspace is enabled} other {# workspaces are enabled}}',
		description:
			'Label for the lozenge indicating connected workspaces status when workspaces are connected',
	},
	msteamsWorkspaceConnectionEnabled: {
		id: 'servicedesk-incident-management-settings.communication-bridges.slack-workspace-connection-summary.msteams-workspace-connection-enabled',
		defaultMessage:
			'{enabledWorkspacesCount, plural, one {# tenant is enabled} other {# tenants are enabled}}',
		description:
			'Label for the lozenge indicating connected tenants status when tenants are connected',
	},
});

export const getWorkspaceConnectionEnabled = (appType: AppType) => {
	switch (appType) {
		case SLACK_APP_TYPE:
			return messages.slackWorkspaceConnectionEnabled;
		case MSTEAM_APP_TYPE:
			return messages.msteamsWorkspaceConnectionEnabled;
		default:
			return messages.slackWorkspaceConnectionEnabled;
	}
};
